module.exports = __webpack_public_path__ + "img/icon_5_56.53aceb49.png";